import styled from '@emotion/styled';

import IconMessage from '@/assets/icons/icon-message.svg';

export const ReviewEmpty = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  text-align: center;

  .empty-icon {
    background-image: url(${IconMessage});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 60px;
    height: 60px;
    margin-bottom: 15px;
  }
`;

export const ReviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 40px;
`;

export const ReviewHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ReviewHeaderInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const ReviewBody = styled.div`
  display: flex;
  gap: 13px;
`;

export const ReviewImageContainer = styled.div`
  width: 70px;
  height: 70px;
  position: relative;
  border-radius: 2px;
  cursor: pointer;
`;

export const ReviewImageCount = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 4px;
  font-size: 10px;
  background-color: #111111;
  color: var(--color-brand-white);
  border-top-left-radius: 4px;
  border-bottom-right-radius: 4px;
`;

export const ReviewContent = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  text-overflow: ellipsis;
  word-wrap: break-word;
  overflow: hidden;
  white-space: pre-wrap;
  display: -webkit-box;
  -webkit-user-drag: none;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;

  &.show-more {
    -webkit-line-clamp: initial;
  }

  &.cursor-pointer {
    cursor: pointer;
  }
`;

export const ReviewShowMore = styled.span`
  cursor: pointer;
`;
